import { Box, SimpleGrid } from "@mantine/core";
import { UseFormReturnType } from "@mantine/form";
import { DatePicker, Select, TextInput } from "components";
import { TFunction } from "i18next";

interface CardPersonalProps {
  form: UseFormReturnType<any, any>;
  t: TFunction;
}

const CardPersonal = ({ form, t }: CardPersonalProps) => {

  return (
    <Box p={'lg'}>
      <SimpleGrid cols={4}>
        <TextInput
          label={t('user.firstName.label')}
          key={form.key('firstName')}
          {...form.getInputProps('firstName')}
          disabled={true}
        />
        <TextInput
          label={t('user.lastName.label')}
          key={form.key('lastName')}
          {...form.getInputProps('lastName')}
          disabled={true}
        />
        <Select
          label={t('user.gender.label')}
          placeholder={t('select.something')}
          key={form.key('gender')}
          {...form.getInputProps('gender')}
          data={form.getInputProps('gender').defaultValue && [{
            value: form.getInputProps('gender').defaultValue,
            label: t(`user.gender.options.${form.getInputProps('gender').defaultValue}`),
          }]}
          disabled={true}
        />
        <DatePicker
          label={t('user.birthDate.label')}
          placeholder={t('user.birthDate.placeholder')}
          key={form.key('birthDate')}
          {...form.getInputProps('birthDate')}
          disabled={true}
        />
      </SimpleGrid>
      <SimpleGrid cols={4} mt={'md'}>
        <TextInput
          label={t('user.phone.label')}
          key={form.key('phone')}
          {...form.getInputProps('phone')}
          disabled={true}
        />
        <TextInput
          label={t('user.email.label')}
          key={form.key('email')}
          {...form.getInputProps('email')}
          disabled={true}
        />
        <Select
          label={t('user.nationality.label')}
          placeholder={t('select.something')}
          key={form.key('nationality')}
          {...form.getInputProps('nationality')}
          data={form.getInputProps('nationality').defaultValue && [{
            value: form.getInputProps('nationality').defaultValue,
            label: t(`user.nationality.options.${form.getInputProps('nationality').defaultValue}`),
          }]}
          disabled={true}
        />
        <Select
          label={t('user.visa.label')}
          placeholder={t('select.something')}
          key={form.key('visaType')}
          {...form.getInputProps('visaType')}
          data={form.getInputProps('visaType').defaultValue && [{
            value: form.getInputProps('visaType').defaultValue,
            label: t(`user.visa.options.${form.getInputProps('visaType').defaultValue}`),
          }]}
          disabled={true}
        />
      </SimpleGrid>
    </Box>
  )
}

export default CardPersonal;